module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiM2QzYzRkYiLz4KPHBhdGggZD0iTTEwLjI3NzMgOC42ODYwNEg3LjEyOTg4VjEySDUuNzcxVjQuMTc5NjlIMTAuNzM5M1Y1LjI3NTM5SDcuMTI5ODhWNy42MDEwN0gxMC4yNzczVjguNjg2MDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat-rate-job-icon.svg
// module id = fKaI
// module chunks = 0